import React, { useCallback, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faUnlockAlt } from '@fortawesome/free-solid-svg-icons';
import { Col, Row, Form, Button, Container, InputGroup } from '@themesberg/react-bootstrap';

import BgImage from '../assets/img/illustrations/signin.svg';
import Logo from '../assets/img/prasha_logo.jpg';
import { useDispatch } from 'react-redux';
import { loginSaga } from 'reduxToolkit/actions';

const LoginPage = () => {
    const dispatch = useDispatch();

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');

    const dispatchLogin = useCallback(() => {
        const loginPayload = {
            email,
            password,
        };
        dispatch(loginSaga(loginPayload));
    }, [dispatch, email, password]);

    return (
        <main>
            <section className="d-flex align-items-center my-5 mt-lg-6 mb-lg-5">
                {/* <button onClick={() => getTestimonialFunc()} type="button">
                    Test
                </button> */}
                <Container>
                    {' '}
                    <Row
                        className="justify-content-center form-bg-image"
                        style={{ backgroundImage: `url(${BgImage})` }}
                    >
                        <Col xs={12} className="d-flex align-items-center justify-content-center">
                            <div className="bg-white shadow-soft border rounded border-light p-4 p-lg-5 w-100 fmxw-500">
                                <div className="text-center text-md-center mb-4 mt-md-0">
                                    {/* <h3 className="mb-0">Sign in to our SPK</h3> */}
                                    <img style={{ width: '50%' }} alt="logo" src={Logo} />
                                </div>
                                <Form className="mt-4">
                                    <Form.Group id="email" className="mb-4">
                                        <Form.Label>Your Email</Form.Label>
                                        <InputGroup>
                                            <InputGroup.Text>
                                                <FontAwesomeIcon icon={faEnvelope} />
                                            </InputGroup.Text>
                                            <Form.Control
                                                value={email}
                                                onChange={(e) => setEmail(e.target.value)}
                                                required
                                                type="email"
                                                placeholder="example@company.com"
                                            />
                                        </InputGroup>
                                    </Form.Group>
                                    <Form.Group>
                                        <Form.Group id="password" className="mb-4">
                                            <Form.Label>Your Password</Form.Label>
                                            <InputGroup>
                                                <InputGroup.Text>
                                                    <FontAwesomeIcon icon={faUnlockAlt} />
                                                </InputGroup.Text>
                                                <Form.Control
                                                    value={password}
                                                    onChange={(e) => setPassword(e.target.value)}
                                                    required
                                                    type="password"
                                                    placeholder="Password"
                                                />
                                            </InputGroup>
                                        </Form.Group>
                                    </Form.Group>
                                    <Button
                                        onClick={() => dispatchLogin()}
                                        variant="primary"
                                        type="button"
                                        className="w-100"
                                    >
                                        Sign in
                                    </Button>
                                </Form>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </main>
    );
};

export default LoginPage;
